module.exports = "<template id=\"perspective-highcharts\">\n    <div id=\"container\">\n\n    </div>\n</template>";


//////////////////
// WEBPACK FOOTER
// ./cjs/html/highcharts.html
// module id = 115
// module chunks = 0